export default __webpack_public_path__ + "img/3f26043d4b21f41ef992e40cbcfae3d4.png";